module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "grey lighten-2 pl-1",
    attrs: {
      "id": "invoiceable-top"
    }
  }, [_c('appointment-action', {
    attrs: {
      "component-name": "CreateInvoice",
      "initial-filters": _vm.filters,
      "initial-relationship": _vm.selectedRelationship,
      "touch": _vm.actionTouch
    },
    on: {
      "success": function($event) {
        _vm.touch++
      }
    }
  }, [_c('template', {
    slot: "ag-filters"
  }, [_c('invoiceable-client-list', {
    attrs: {
      "touch": _vm.touch
    },
    on: {
      "update:params": _vm.setFilters,
      "selected": _vm.setRelationship
    }
  })], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1f270b4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/layout/Invoiceable/Index.vue
// module id = 1538
// module chunks = 9